import * as styled from '../styles/section-heading';

type Props = {
  kicker?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  onDark?: boolean;
};

export const SectionHeading = ({ kicker, title, subtitle, align, onDark }: Props) => (
  <styled.Wrap $align={align}>
    {kicker && <styled.Kicker>{kicker}</styled.Kicker>}
    <styled.Title $onDark={onDark}>{title}</styled.Title>
    {subtitle && <styled.Subtitle $onDark={onDark}>{subtitle}</styled.Subtitle>}
  </styled.Wrap>
);
